import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class MwSmartSearchPage extends Component {
  @service router;
  @action
  goToPage() {
    this.router.transitionTo('app.publicid.feed', this.args.page.publicLinkId);
  }
}
